<template>
    <div class="list">
        <ul>
            <li v-for="(item,index) of list" :key="index">
                <router-link :to="{path:item.path,query:{id:$route.query.id}}">
                    <img :src="item.icon">
                    <span>{{item.name}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            list:[
                {icon: require('../../../assets/icon/service.png'), name: '咨询客服', path:''},
                {icon: require('../../../assets/icon/return.png'), name: '我要退款', path:'/barter'},
                {icon: require('../../../assets/icon/change.png'), name: '我要换货', path:'/refund'}
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
    .list{
        font-size: .32rem;
        margin-top: 3rem;
        ul{
            li{
                text-align: center;
                margin: 0.2rem;
                background: white;
                padding: 0.6rem 2rem;
            
                a{
                    display: block;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #333333;

                }
                img{
                    width: .51rem;
                    height: .51rem;
                }
                span{
                    height: .51rem;
                    line-height: .51rem;
                }
            }
        }
    }
</style>
